var modules_997b7aad = {"container":"_1kze2nx","important":"_1vb8cdq","text-wrapper":"_1lin4d3"};
import "../../../assets/uJ0ADxye.css";

export { modules_997b7aad as default };
//# sourceMappingURL=Logo.module.less.js.map
